export interface ButtonProps {
  /** 类型 */
  variant: 'Primary' | 'Secondary' | 'Text';
  size: ButtonSize;
  /** 文案 */
  title?: string;
  /** loading状态文案 */
  loadingTitle?: string;
  /** icon */
  icon?: HTMLElement;
  /** 状态 */
  status?: ButtonStatus;
  /** 颜色 Primary类型中可设置 */
  color?: string;
  /** 文案颜色 */
  titleColor?: string;
  /** 圆角 */
  borderRadius?: number;
  /** 最小宽度 */
  minWidth?: string;
  /** 最大高度 */
  maxWidth?: string;
  /** 主题 */
  mode?: 'White' | 'Dark';
  /** 可添加className */
  className?: string;
  /** 点击事件 */
  onClick?: () => void;
}

export enum ButtonStatus {
  default = 'Default',
  disabled = 'Disabled',
  loading = 'Loading'
}

export enum ButtonSize {
  large = 'Large',
  medium = 'Medium',
  small = 'Small'
}
